export const STORAGE_KEYS = {
  defaultPersona: 'defaultPersona'
};
